import { plainToInstance } from 'class-transformer';
import { observer } from 'mobx-react-lite';
import { useCallback, useMemo, useState } from 'react';
import { PromotionService } from '~/service/service.promotion';
import { UIService } from '~/service/service.ui';
import { PromotionBestsellerDto } from '~/shared/dto/admin/promotion.dto';
import { Form } from '~/shared/form';
import { useService } from '~/shared/service/service.base';
import { PromotionBestsellerDialog } from '../dialog/dialog.promotion.fragrance';
import { PromotionDraggableList } from './promotion.list';

export type PromotionBestsellersProps = {
	field: Form.Field<PromotionBestsellerDto[]>;
};

export const PromotionBestsellers = observer(({ field }: PromotionBestsellersProps) => {
	const [ui, promotion] = useService(UIService, PromotionService);
	const [initial, setInitial] = useState<PromotionBestsellerDto | undefined>(undefined);

	const handleApply = useCallback(
		(bestseller: PromotionBestsellerDto) => {
			const arr = Array.from(field.value || []);
			const index = arr.findIndex(o => o.fragranceId === bestseller.fragranceId);
			if (index >= 0) arr[index] = bestseller;
			else {
				bestseller.order = arr.length + 1;
				arr.push(bestseller);
			}
			field.set(arr);
		},
		[field],
	);

	const hadnleAdd = useMemo(() => {
		return (bestseller?: PromotionBestsellerDto) => {
			setInitial(bestseller || plainToInstance(PromotionBestsellerDto, { order: 1 }));
			ui.showDialog(PromotionBestsellerDialog);
		};
	}, [ui]);

	const handleDelete = useCallback(
		(bestseller: PromotionBestsellerDto) => {
			const arr = field.value?.filter(b => b.fragranceId !== bestseller.fragranceId) || [];
			arr.forEach((item, idx) => (item.order = idx + 1));
			field.set(arr);
		},
		[field],
	);

	const fragrances = promotion.fragrances.map(f => ({
		...f,
		active: f.active && !field.value?.some(o => o.fragranceId === f.id),
	}));

	return (
		<>
			<PromotionDraggableList label="Bestseller" field={field} onAdd={hadnleAdd} onDelete={handleDelete} />
			<PromotionBestsellerDialog fragrances={fragrances} initial={initial} onApply={handleApply} />
		</>
	);
});
